<template>
  <section class="custom-vehicle">
    <contact-summary
      class="mb-4"
      :contact="value"
    />
    <div class="row">
      <div class="col-md-4">
        <dt-input
          v-model="year"
          name="year"
          label="Year"
          type="Number"
          min="1970"
          max="2050"
          validate="required"
        />
      </div>
      <div class="col-md-8">
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <dt-select
          v-model="make"
          label="Make"
          name="make"
          :options="lookups['VehicleMake']"
          validate="required"
        />
      </div>
      <div class="col-md-6">
        <dt-input
          v-model="model"
          name="model"
          label="Model"
          validate="required"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <dt-input
          v-model="vin"
          name="vin"
          label="VIN"
          validate="required"
        />
      </div>
      <div class="col-md-6">
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import DtInput from '@/components/utilities/form/dt-input'
import DtSelect from '@/components/utilities/form/dt-select'
import ContactSummary from '@/components/contacts/forms/contact-summary'
export default {
  name: 'contact-vehicle',
  components: {
    DtInput,
    DtSelect,
    ContactSummary
  },
  props: {
    value: {
      type: Object
    }
  },
  async mounted() {
    // if (this.value !== undefined && this.value !== null) {
    //   await this.getVehicle(this.value.vehicle)
    // }
  },
  computed: {
    ...mapGetters('lookups', ['lookups']),
    ...mapGetters('vehicles', ['vehicle']),
    year: {
      get() {
        return this.vehicle !== null ? this.vehicle.year.toString() : '2007'
      },
      set(value) {
        this.updateVehicle({
          name: 'year',
          value: parseInt(value)
        })
      }
    },
    make: {
      get() {
        return this.vehicle !== null ? this.vehicle.make : '0'
      },
      set(value) {
        this.updateVehicle({
          name: 'make',
          value: value
        })
      }
    },
    model: {
      get() {
        return this.vehicle !== null ? this.vehicle.model : ''
      },
      set(value) {
        this.updateVehicle({
          name: 'model',
          value: value
        })
      }
    },
    vin: {
      get() {
        return this.vehicle !== null ? this.vehicle.vin : ''
      },
      set(value) {
        this.updateVehicle({
          name: 'vin',
          value: value
        })
      }
    },
    isVisible: {
      get() {
        return this.value !== null
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    ...mapActions('vehicles', ['getVehicle', 'updateVehicle'])
  }
}
</script>
<style lang="scss" scoped>
.custom-vehicle {
  width: 100%;
  padding-left: 15px;
  padding-right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/contacts/forms/vehicle.vue